<form class="d-flex gap-48" [formGroup]="form">
  <div class="flex-grow-1 w-0">
    <div>
      <p class="t2 c-t-gray-500 fw-medium text-uppercase">
        {{ 'Personal information' | trans:'customers/customer-details-modal/overview-form/personal-information.Label' }}
      </p>

      <div class="d-flex m-t-16 gap-12">
        <p class="fw-medium p2 c-t-blue-900">
          {{ 'Status' | trans:'customers/customer-details-modal/overview-form/status.Label' }}
        </p>
        <div class="tag tag--{{ data.customerStatusKey }}">
          {{ data.customerStatusKey | trans:'customers/customer-details-modal/overview-form/statusKey.' + data.customerStatusKey }}
        </div>
      </div>

      <div class="m-t-16">
        <app-form-control
          class="full-width"
          label="{{ 'Client number'| trans:'customers/customer-details-modal/overview-form/customer-number.Label' }}"
          [isRequired]="true"
        >
          <input
            type="text"
            placeholder="{{ 'Enter client number'| trans:'customers/customer-details-modal/overview-form/customer-number.Placeholder' }}"
            readonly
            [value]="data.customerNumber"
          >
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-24">
        <app-form-control
          label="{{ 'Anrede' | trans:'customers/forms/add-edit-customer-form/title.Label' }}"
          [hasErrors]="hasControlErrors('title')"
          class="full-width"
          max-width="160px"
          [isRequired]="true"
        >
          <app-select
            formControlName="title"
            class="full-width"
            outputType="string"
            [hasResetOption]="false"
            [canUnselect]="false"
            [hasErrors]="hasControlErrors('title')"
            [options]="titleOptions | idAndName"
          />
        </app-form-control>

        @if ((getControl('title').value | lowercase) === (('Firma' | trans:'customers/forms/add-edit-customer-form/title-options.Firma') | lowercase)) {
          <app-form-control
            class="w-0 flex-grow-1"
            label="{{ 'Company name'| trans:'customers/customer-details-modal/overview-form/companyName.Label' }}"
            [hasErrors]="hasControlErrors('companyName')"
          >
            <input
              type="text"
              placeholder="{{ 'Enter company Name'| trans:'customers/customer-details-modal/overview-form/companyName.Placeholder' }}"
              formControlName="companyName"
            >
          </app-form-control>
        }
      </div>
    </div>

    <div class="m-t-24">
      <p class="t2 c-t-gray-500 fw-medium text-uppercase">
        {{ 'DATEN DER KONTAKTPERSON' | trans:'customers/customer-details-modal/overview-form/contact-person.Label' }}
      </p>

      <div class="d-flex gap-12 m-t-16">
        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'First name'| trans:'customers/customer-details-modal/overview-form/firstName.Label' }}"
          [isRequired]="true"
          [hasErrors]="hasControlErrors('firstName')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter first name'| trans:'customers/customer-details-modal/overview-form/firstName.Placeholder' }}"
            formControlName="firstName"
          >
        </app-form-control>

        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Last name'| trans:'customers/customer-details-modal/overview-form/lastName.Label' }}"
          [isRequired]="true"
          [hasErrors]="hasControlErrors('lastName')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter last name'| trans:'customers/customer-details-modal/overview-form/lastName.Placeholder' }}"
            formControlName="lastName"
          >
        </app-form-control>
      </div>

      <div class="m-t-16 d-flex gap-12">
        <app-datepicker
          formControlName="birthDate"
          class="full-width d-block"
          max-width="160px"
          label="{{ 'Date of birth' | trans:'customers/customer-details-modal/overview-form/birthDate.Label' }}"
          [hasErrors]="hasControlErrors('birthDate')"
        />

        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Email'| trans:'customers/customer-details-modal/overview-form/email.Label' }}"
          [isRequired]="true"
          [hasErrors]="hasControlErrors('email')"
        >
          <input
            type="email"
            placeholder="{{ 'Enter email'| trans:'customers/customer-details-modal/overview-form/email.Placeholder' }}"
            formControlName="email"
          >
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-16">
        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Street'| trans:'customers/customer-details-modal/overview-form/steet.Label' }}"
          [hasErrors]="hasControlErrors('street')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter street'| trans:'customers/customer-details-modal/overview-form/street.Placeholder' }}"
            formControlName="street"
          >
        </app-form-control>

        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'City'| trans:'customers/customer-details-modal/overview-form/city.Label' }}"
          [hasErrors]="hasControlErrors('city')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter city'| trans:'customers/customer-details-modal/overview-form/city.Placeholder' }}"
            formControlName="city"
          >
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-16">
        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Country'| trans:'customers/customer-details-modal/overview-form/country.Label' }}"
          [isRequired]="true"
          [hasErrors]="hasControlErrors('countryId')"
        >
          <app-select
            class="full-width"
            [options]="countries()"
            [placeholder]="'Select country' | trans:'customers/customer-details-modal/overview-form/country.Placeholder'"
            [hasResetOption]="false"
            outputType="number"
            [canUnselect]="false"
            formControlName="countryId"
          />
        </app-form-control>

        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Zip code'| trans:'customers/customer-details-modal/overview-form/postalCode.Label' }}"
          [hasErrors]="hasControlErrors('postalCode')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter postalCode'| trans:'customers/customer-details-modal/overview-form/postalCode.Placeholder' }}"
            formControlName="postalCode"
          >
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-16">
        <app-form-control
          class="full-width"
          max-width="90px"
          label="{{ 'Vorwahl'| trans:'customers/customer-details-modal/overview-form/areaCode.Label' }}"
          [hasErrors]="hasControlErrors('areaCode')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter Vorwahl'| trans:'customers/customer-details-modal/overview-form/areaCode.Placeholder' }}"
            formControlName="areaCode"
          >
        </app-form-control>

        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Phone number'| trans:'customers/customer-details-modal/overview-form/phoneNumber.Label' }}"
          [hasErrors]="hasControlErrors('phoneNumber')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter phone number'| trans:'customers/customer-details-modal/overview-form/phoneNumber.Placeholder' }}"
            formControlName="phoneNumber"
          >
        </app-form-control>
      </div>
    </div>
  </div>
  <div class="left-separator p-l-48 flex-grow-1 w-0">
    <div>
      <p class="t2 c-t-gray-500 fw-medium text-uppercase">
        {{ 'Account & preferences' | trans:'customers/customer-details-modal/overview-form/account-preferences.Label' }}
      </p>

      <div class="m-t-16">
        <app-form-control
          class="full-width"
          label="{{ 'Nickname'| trans:'customers/customer-details-modal/overview-form/nickname.Label' }}"
          [hasErrors]="hasControlErrors('nickname')"
        >
          <input
            type="text"
            placeholder="{{ 'Enter nickname'| trans:'customers/customer-details-modal/overview-form/nickname.Placeholder' }}"
            formControlName="nickname"
          >
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-16">
        <app-form-control
          class="full-width"
          max-width="160px"
          label="{{ 'Language'| trans:'customers/customer-details-modal/overview-form/language.Label' }}"
          [hasErrors]="hasControlErrors('prefLanguageId')"
        >
          <app-select
            class="full-width"
            [options]="languages()"
            [placeholder]="'Select Language' | trans:'customers/customer-details-modal/overview-form/language.Placeholder'"
            [hasResetOption]="false"
            outputType="number"
            [canUnselect]="false"
            formControlName="prefLanguageId"
          />
        </app-form-control>

        <app-form-control
          class="full-width"
          max-width="160px"
          label="{{ 'Currency'| trans:'customers/customer-details-modal/overview-form/currency.Label' }}"
          [hasErrors]="hasControlErrors('prefCurrencyId')"
        >
          <app-select
            class="full-width"
            [options]="currencies() | idAndName:'id':'token'"
            [placeholder]="'Select currency' | trans:'customers/customer-details-modal/overview-form/currency.Placeholder'"
            [hasResetOption]="false"
            outputType="number"
            [canUnselect]="false"
            formControlName="prefCurrencyId"
          />
        </app-form-control>
      </div>

      <div class="d-flex gap-12 m-t-32 align-items-end">
        <app-form-control
          class="w-0 flex-grow-1"
          label="{{ 'Password'| trans:'customers/customer-details-modal/overview-form/password.Label' }}"
        >
          <input
            type="password"
            readonly
            value="********"
          >
        </app-form-control>

        <button
          class="button button--primary-ghost fw-semibold p2"
          min-height="42px"
          type="button"
          max-height="42px"
          (click)="resetPassword()"
        >
          <i class="ri-refresh-line icon-sm"></i>
          {{ 'Reset' | trans:'customers/customer-details-modal/overview-form/password.ResetButton' }}
        </button>
      </div>

      <div class="m-t-12 d-flex gap-12 align-items-center">
        <p class="fw-medium p2">
          {{ 'Login attempts' | trans:'customers/customer-details-modal/overview-form/loginAttempts.Label' }}:
        </p>
        <p>
          {{ data.loginAttempts }}
        </p>
      </div>
    </div>

    <div class="m-t-24">
      <p class="t2 c-t-gray-500 fw-medium text-uppercase">
        {{ 'Note' | trans:'customers/customer-details-modal/overview-form/note.Label' }}
      </p>

      <div class="m-t-16 d-flex align-items-center gap-24 align-items-center">
        <app-content-box
          theme="orange"
          padding="p-x-8 p-y-12"
          borderRadius="base-border-radius"
          class="w-0 flex-grow-1"
        >
          @if (getControl('remark').value) {
            <div class="p2 white-space-pre-wrap">{{ getControl('remark').value }}</div>
          } @else {
            <div class="p2">
              {{ 'No notes.' | trans: 'note/no-notes.Text' }}
            </div>
          }
        </app-content-box>

        <button
          class="button button--icon-sm button--primary-ghost"
          (click)="addNoteModalComponent.open(getControl('remark').value)"
        >
          <i class="ri-pencil-line"></i>
        </button>
      </div>
    </div>
  </div>
</form>

<app-add-note-modal
  #addNoteModalComponent
  (noteChange)="getControl('remark').patchValue($event)"
/>
